export enum DefaultEnvImages {
  Logo = 'header-logo.png',
  Favicon = 'favicon.png',
  FooterLogo = 'footer-logo.png',
}
